





























import { Component, Vue } from 'vue-property-decorator'

@Component
export default class LayoutAuthCenter extends Vue {
  goToLogin() {
    this.$router.push({ name: 'login' })
  }
}
